module.exports = __webpack_public_path__ + "static/media/bitcoin.5e3c0cc0.jpg";